import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSetLink, useSetLinkId } from '../state';
import fetchWithToken from '../services';
import Loading from './Loading';

const SetLink = () => {
    const setLink = useSetLink();
    const setLinkId = useSetLinkId();
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const baseUrl = process.env.REACT_APP_BASE_URL;

    useEffect(() => {
        const getLinkId = async () => {
            try {
                const res = await fetchWithToken('/get-link-id');

                if (!res.ok) {
                    throw new Error(`Failed to fetch link ID: ${res.status}`);
                }

                const data = await res.json();
                const { linkId } = data;
                const link = `${baseUrl}/${linkId}`;
                setLinkId(linkId);
                setLink(link);
            } catch (err) {
                console.error('Error fetching link ID:', err);
                navigate('/error');
            } finally {
                setIsLoading(false);
            }
        }

        getLinkId();
    }, [setLink, setLinkId]);

    if (isLoading) {
        return <Loading />;
    }

    return null; // The link is set in context, no need to render anything
};

export default SetLink;
